var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountainIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "22px",
    viewBox: "0 0 29 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke",
    id: "All-Categories",
    transform: "translate(-25.000000, -109.000000)",
    stroke: "#F05F4B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(26.000000, 110.620047)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -1.77635684e-15,
    y: -1.77635684e-15,
    width: 26.9641185,
    height: 19.1299527
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    strokeLinecap: "round",
    transform: "translate(15.046979, 12.029070) rotate(-90.000000) translate(-15.046979, -12.029070) ",
    points: "7.94609698 0.111931183 22.147862 14.201712 13.2568953 23.9462092"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1-Copy",
    strokeLinecap: "round",
    transform: "translate(5.395996, 9.469508) rotate(-90.000000) translate(-5.395996, -9.469508) ",
    points: "1.99699766 4.07351146 8.79499512 10.9209286 4.80980778 14.8655042"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountainIc);
export default __webpack_public_path__ + "static/media/mountain-ic.7da190a94e9b53d2c0e340c1d5a0d43f.svg";
export { ForwardRef as ReactComponent };